import React from "react";
import { makeStyles, Button, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  giftContainer: {
    position: "relative",
    textAlign: "center",
  },
  media: {
    width: "100%",
    height: "100%",
  },
  btnCard: {
    marginTop: -26,
    textTransform: "none",
    backgroundColor: theme.palette.primary.main,
    color: "#ffffff",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  giftText: {
    marginBottom: 6,
    marginTop: 25,
    color: theme.palette.primary.main,
  },
}));

export default function GiftCard({ price, hour, text }) {
  const classes = useStyles();

  return (
    <div className={classes.giftContainer}>
      <img
        className={classes.media}
        alt="img"
        src="https://www.jotform.com/resources/assets/icon/min/jotform-icon-dark-400x400.png"
      />

      <Button variant="outlined" color="primary" className={classes.btnCard}>
        {price}
      </Button>
      <Typography className={classes.giftText} variant="h3" color="primary">
        {text}
      </Typography>
      <Typography color="secondary" variant="subtitle1">
        {hour}
      </Typography>
    </div>
  );
}

GiftCard.defaultProps = {
  price: "price",
};
